<template>
  <div class="mt-2">
    <div class="row parent-div">
      <!-- Date Picker and PH Filter -->
      <div class="col-3 cal-div">
        <div class="card mb-3 ph-div" v-if="countries && countries.length">
          <div class="card-body p-3">
            <table
              v-if="tokenObj.UserType != userTypeStudent"
              class="table table-bordered custom-table mb-0 ph-table"
            >
              <thead class="thead-light">
                <tr>
                  <th class="d-flex align-items-center">
                    <input
                      type="checkbox"
                      id="chkAllPh"
                      class="mr-1"
                      v-model="showAllPh"
                      @change="showAllPhCheckChange"
                    />
                    <label
                      for="chkAllPh"
                      style="margin-top: 3px; margin-bottom: 0"
                    >
                      Show Public Holidays
                    </label>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div
                      v-for="item in countries"
                      :key="item.Id"
                      class="d-flex align-items-center"
                    >
                      <input
                        :id="`chk${item.Id}`"
                        type="checkbox"
                        class="mr-1"
                        v-model="item.Selected"
                        @change="countryCheckChange"
                      />
                      <label
                        :for="`chk${item.Id}`"
                        style="margin-top: 3px; margin-bottom: 0"
                      >
                        {{ item.Name }}
                      </label>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <template v-else>
              <div
                v-for="item in countries"
                :key="item.Id"
                class="d-flex align-items-center"
              >
                <input
                  :id="`chk${item.Id}`"
                  type="checkbox"
                  class="mr-1"
                  v-model="item.Selected"
                  @change="countryCheckChange"
                />
                <label
                  :for="`chk${item.Id}`"
                  style="
                    margin-top: 0;
                    margin-bottom: 0;
                    line-height: 1;
                    font-size: 13px;
                  "
                >
                  Show public holidays in my location
                </label>
              </div>
            </template>
          </div>
        </div>
        <v-date-picker
          :first-day-of-week="0"
          :model-config="modelConfig"
          :key="counter"
          v-model="selectedDate"
        />
      </div>
      <!-- /Date Picker and PH Filter -->

      <!-- Calendar -->
      <div class="schedule-div px-md-0 px-lg-0">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-8">
                <div class="navigation-div">
                  <button class="btn btn-light mr-3" @click="today">
                    Today
                  </button>
                  <button class="btn btn-light mr-3" @click="previous">
                    <i class="fas fa-less-than"></i>
                  </button>
                  <button class="btn btn-light mr-3" @click="next">
                    <i class="fas fa-greater-than"></i>
                  </button>
                  <label class="period-lbl" style="margin-bottom: 0 !important">
                    <h5 style="margin-bottom: 0 !important">
                      {{ displayedPeriod }}
                    </h5>
                  </label>
                </div>
              </div>
              <div class="col-4">
                <div class="navigation-div text-right">
                  <button
                    :class="
                      selectedView == 'Day'
                        ? 'selected btn btn-light mr-3'
                        : 'btn btn-light mr-3'
                    "
                    @click="changeView('Day')"
                  >
                    Day
                  </button>
                  <button
                    :class="
                      selectedView == 'Week'
                        ? 'selected btn btn-light mr-3'
                        : 'btn btn-light mr-3'
                    "
                    @click="changeView('Week')"
                  >
                    Week
                  </button>
                  <button
                    :class="
                      selectedView == 'Month'
                        ? 'selected btn btn-light'
                        : 'btn btn-light'
                    "
                    @click="changeView('Month')"
                  >
                    Month
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <component
                  :is="selectedView"
                  :selectedDate="selectedDate"
                  :selectedCountries="selectedCountries"
                  :schoolId="schoolId"
                  :subjectName="subjectName"
                  :subjectLevelName="subjectLevelName"
                  :duration="duration"
                  :makeupClass="makeupClass"
                  :studentName="studentName"
                  :instructorName="instructorName"
                  :startDate="startDate"
                  :endDate="endDate"
                  :statuses="statuses"
                  :instructorId="instructorId"
                  :studentId="studentId"
                  :startTimeHour="startTimeHour"
                  :startTimeMinute="startTimeMinute"
                  :startTimePart="startTimePart"
                  :endTimeHour="endTimeHour"
                  :endTimeMinute="endTimeMinute"
                  :endTimePart="endTimePart"
                  :key="counter"
                  @showPublicHoliday="showPublicHoliday"
                  @showClass="showClass"
                  @showMore="showMore"
                ></component>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Calendar -->
    </div>

    <!-- Public Holiday Modal -->
    <div class="modal custom-modal fade" id="phModal" role="dialog">
      <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header pb-0" style="border: 1px solid #dee2e6">
            <h5 class="modal-title">Public Holiday</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body px-3 pt-3 pb-0">
            <form>
              <div class="form-group">
                <label class="mb-0"><b>Event Name</b></label>
                <div>{{ eventName }}</div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="form-group col-6 mb-0">
                    <label class="mb-0"><b>Date</b></label>
                    <div
                      v-html="formatDate(date)"
                      style="line-height: 17px"
                    ></div>
                  </div>
                  <div class="form-group col-6 mb-0">
                    <label class="mb-0"><b>Country</b></label>
                    <div>{{ country }}</div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- /Public Holiday Modal-->

    <!-- Event Modal -->
    <div class="modal custom-modal fade" id="classModal" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" :style="`background-color:${color}`">
          <div
            class="modal-header pb-0"
            style="border-bottom: 1px solid darkgray"
          >
            <h5 class="modal-title">{{ eventName }} ({{ classDuration }})</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body px-3 pt-3 pb-0">
            <div class="form-group">
              <div class="row">
                <div class="form-group col-6 mb-0">
                  <label class="mb-0"><b>School</b></label>
                  <div>{{ school }}</div>
                </div>
                <div class="form-group col-6 mb-0">
                  <label class="mb-0"><b>Student</b></label>
                  <div>{{ student }}</div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="form-group col-6 mb-0">
                  <label class="mb-0"><b>Date</b></label>
                  <div>{{ date }}</div>
                </div>
                <div class="form-group col-6 mb-0">
                  <label class="mb-0"><b>Time</b></label>
                  <div>{{ time }}</div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="form-group col-6 mb-0">
                  <label class="mb-0"><b>Instructor</b></label>
                  <div>{{ instructor }}</div>
                </div>
                <div class="form-group col-6 mb-0">
                  <label class="mb-0"><b>Make-up Class</b></label>
                  <div>{{ makeup }}</div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="form-group col-6 mb-0">
                  <label class="mb-0"><b>Location</b></label>
                  <div>{{ location }}</div>
                </div>
                <div class="form-group col-6 mb-0">
                  <label class="mb-0"><b>Class Fee</b></label>
                  <div>{{ fee }}</div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="form-group col-6 mb-0">
                  <label class="mb-0"><b>Status</b></label>
                  <div>{{ status }}</div>
                </div>
              </div>
            </div>

            <div class="text-center mt-0 mb-4">
              <button
                v-if="status != 'Cancelled'"
                type="button"
                :class="
                  (!isStudent && status == 'Pending Confirmation') ||
                  (isInstructor && canChangeToPending)
                    ? 'btn btn-danger mx-2 w-xs-40'
                    : 'btn btn-danger mx-2'
                "
                @click="cancel"
              >
                Cancel Class Booking
              </button>
              <button
                v-if="!isStudent && status == 'Pending Confirmation'"
                type="button"
                class="btn btn-success mx-2 w-xs-40"
                @click="confirm"
              >
                Confirm Class Booking
              </button>
              <button
                v-if="isStudent"
                type="button"
                class="btn btn-success mx-2"
                @click="print"
              >
                Print
              </button>
              <button
                v-if="isInstructor && canChangeToPending"
                type="button"
                class="btn btn-secondary w-xs-50"
                @click="changeToPending"
              >
                Change to Pending Confirmation
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Event Modal -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config.js";
import Month from "./ClassBookingCalendarFormatMonth.vue";
import Week from "./ClassBookingCalendarFormatWeek.vue";
import Day from "./ClassBookingCalendarFormatDay.vue";
import $ from "jquery";
import axios from "axios";
export default {
  props: [
    "schoolId",
    "subjectName",
    "subjectLevelName",
    "duration",
    "makeupClass",
    "studentName",
    "instructorName",
    "startDate",
    "endDate",
    "statuses",
    "instructorId",
    "studentId",
    "startTimeHour",
    "startTimeMinute",
    "startTimePart",
    "endTimeHour",
    "endTimeMinute",
    "endTimePart",
  ],
  components: {
    Month,
    Week,
    Day,
  },
  data() {
    return {
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      userTypeSchoolAdmin: config.USERTYPE_SCHOOL_ADMIN,
      userTypeInstructor: config.USERTYPE_INSTRUCTOR,
      userTypeInstructorSchoolAdmin:
        config.USERTYPE_INSTRUCTOR_AND_SCHOOL_ADMIN,
      userTypeStudent: config.USERTYPE_STUDENT,
      selectedView: "Month",
      selectedDate: "",
      modelConfig: {
        type: "string",
        mask: "YYYY-MM-DD",
      },
      displayedPeriod: "",
      counter: 0,
      //for ph
      showAllPh: false,
      countries: [],
      selectedCountries: [],
      //for class booking and ph modal
      classBookingId: "",
      eventName: "",
      classDuration: "",
      school: "",
      student: "",
      instructor: "",
      date: "",
      time: "",
      makeup: "",
      location: "",
      fee: "",
      status: "",
      color: "",
      country: "",
      canChangeToPending: false,
    };
  },

  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
    todayDate() {
      let date = new Date();
      let day = date.getDate().toString().padStart(2, "0");
      let month = (date.getMonth() + 1).toString().padStart(2, "0");
      let year = date.getFullYear();
      return `${year}-${month}-${day}`;
    },
    isMainAdmin() {
      return this.tokenObj.UserType == this.userTypeMainAdmin;
    },
    isSchoolAdmin() {
      return (
        this.tokenObj.UserType == this.userTypeSchoolAdmin ||
        (this.tokenObj.UserType == this.userTypeInstructorSchoolAdmin &&
          this.$route.path.includes("/schooladmin/"))
      );
    },
    isInstructor() {
      return (
        (this.tokenObj.UserType == this.userTypeInstructorSchoolAdmin ||
          this.tokenObj.UserType == this.userTypeInstructor) &&
        this.$route.path.includes("/instructor/") &&
        !this.$route.path.includes("/schooladmin/")
      );
    },
    isStudent() {
      return (
        this.tokenObj.UserType == this.userTypeStudent &&
        this.$route.path.includes("/student/")
      );
    },
  },

  watch: {
    selectedDate(val) {
      if (val) {
        this.getDisplayedPeriod();
        this.counter++;
      }
    },
    selectedView() {
      if (!this.selectedDate) this.selectedDate = this.todayDate;
      this.getDisplayedPeriod();
      this.counter++;
    },
    "$store.state.expandSidebar": function (val) {
      this.resize();
    },
  },

  methods: {
    formatDate(val) {
      if (!val) return "";
      if (val.includes(",")) return val.replace(",", ",<br/>");
    },
    changeView(view) {
      this.selectedView = view;
      this.$store.state.classFilter.selectedView = view;
    },
    today() {
      this.selectedDate = this.todayDate;
      this.$store.state.classFilter.selectedDate = this.todayDate;
    },
    previous() {
      let param = {
        Token: this.tokenObj.Token,
        Date: this.selectedDate,
        View: this.selectedView,
      };
      API.schedule
        .getPreviousDate(param)
        .then((response) => {
          if (response.data.success) {
            this.selectedDate = response.data.previousDate;
            this.$store.state.classFilter.selectedDate = this.selectedDate;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    next() {
      let param = {
        Token: this.tokenObj.Token,
        Date: this.selectedDate,
        View: this.selectedView,
      };
      API.schedule
        .getNextDate(param)
        .then((response) => {
          if (response.data.success) {
            this.selectedDate = response.data.nextDate;
            this.$store.state.classFilter.selectedDate = this.selectedDate;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getDisplayedPeriod() {
      let param = {
        Token: this.tokenObj.Token,
        Date: this.selectedDate,
        View: this.selectedView,
      };
      API.schedule
        .getDisplayedPeriod(param)
        .then((response) => {
          if (response.data.success) {
            this.displayedPeriod = response.data.displayedPeriod;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    showClass(payload) {
      if (payload) {
        this.classBookingId = payload.classBookingId;
        this.eventName = payload.eventName;
        this.classDuration = payload.duration;
        this.school = payload.school;
        this.student = payload.student;
        this.instructor = payload.instructor;
        this.date = payload.date;
        this.time = payload.time;
        this.makeup = payload.makeupClass;
        this.location = payload.location;
        this.fee = payload.fee;
        this.status = payload.status;
        this.canChangeToPending = payload.canChangeToPending;
        if (this.status == "Confirmed") this.color = "#D9EBFC";
        else if (this.status == "Pending Confirmation") this.color = "#DCDCDC";
        else if (this.status == "Cancelled") this.color = "#FCDCDC";
        $("#classModal").modal("show");
      }
    },
    showMore(date) {
      this.selectedView = "Day";
      this.selectedDate = date;
      this.counter++;
    },
    //action button
    cancel() {
      let param = {
        Token: this.tokenObj.Token,
        Id: this.classBookingId,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to cancel the class booking?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.classBooking
            .cancelClassBooking(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.counter++;
                $("#classModal").modal("hide");
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    confirm() {
      let param = {
        Token: this.tokenObj.Token,
        Id: this.classBookingId,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to confirm the class booking?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.classBooking
            .confirmClassBooking(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.counter++;
                $("#classModal").modal("hide");
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    changeToPending() {
      let param = {
        Token: this.tokenObj.Token,
        Id: this.classBookingId,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to change the class booking to Pending Confirmation?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.classBooking
            .changeClassBookingToPending(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.counter++;
                $("#classModal").modal("hide");
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    print() {
      let param = {
        Token: this.tokenObj.Token,
        Id: this.classBookingId,
      };
      API.classBooking
        .getClassBookingDetail(param)
        .then((response) => {
          if (response.data.success) {
            let data = response.data.data;

            let locationHtml = `${
              data.Location
                ? `<div class="form-row">
                <div class="form-group col-md-5">
                  <label><b>Location</b></label>
                  <div>${data.Location}</div>
                </div>
                ${
                  data.Location == "School Address"
                    ? `<div class="form-group col-md-5">
                  <label><b>School Address</b></label>
                  <div>${data.LocationSchoolAddressName}</div>
                </div>`
                    : ""
                }
              </div>`
                : ""
            }`;

            let paymentHtml = "";
            if (data.MakeupClass == "No") {
              let paymentDetailHtml = "";
              if (data.PaymentOption == "Electronic Bank Transfer") {
                paymentDetailHtml = `<div class="form-row">
                    <div class="form-group col-md-5">
                      <label><b>UEN</b></label>
                      <div>${data.UEN}</div>
                    </div>
                    <div class="form-group col-md-5">
                      <label><b>SWIFT Code</b></label>
                      <div>${data.SwiftCode}</div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-5">
                      <label><b>Account Number</b></label>
                      <div>${data.AccountNumber}</div>
                    </div>
                    <div class="form-group col-md-5">
                      <label><b>Account Name</b></label>
                      <div>${data.AccountName}</div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-5">
                      <label><b>Bank Name</b></label>
                      <div>${data.BankName}</div>
                    </div>
                    <div class="form-group col-md-5">
                      <label><b>Bank Address</b></label>
                      <div>${data.BankAddress}</div>
                    </div>
                  </div>
                  ${
                    data.paymentProof
                      ? `<div class="form-row">
                    <div class="form-group col-md-5">
                      <label><b>Payment File</b></label>
                      <div>${data.PaymentProofFileName}</div>
                    </div>
                  </div>`
                      : ""
                  }`;
              } else if (
                data.PaymentOption == "QR Payment" ||
                data.PaymentOption == "Crossed Cheque"
              ) {
                paymentDetailHtml = `<div class="form-row">
                    ${
                      data.PaymentOption == "QR Payment"
                        ? `<div class="form-group col-md-5">
                          <label><b>UEN</b></label>
                          <div>${data.UEN}</div>
                        </div>`
                        : ""
                    }
                    ${
                      data.PaymentProof
                        ? `<div class="form-group col-md-5">
                          <label><b>Payment File</b></label>
                          <div>${data.PaymentProofFileName}</div>
                        </div>`
                        : ""
                    }
                  </div>`;
              }
              paymentHtml = `<div class="card">
                <div class="card-header text-center">
                  <h3>Payment</h3>
                </div>
                <div class="card-body">
                  <div class="form-row">
                    <div class="form-group col-md-5">
                      <label><b>Total</b></label>
                      <div>
                        ${data.Currency} ${data.FeeAmountPaid}
                      </div>
                    </div>
                    <div class="form-group col-md-5">
                      <label><b>Payment Option</b></label>
                      <div>${data.PaymentOption}</div>
                    </div>
                  </div>
                  ${paymentDetailHtml}
                </div>
              </div>`;
            }

            let confirmedByHtml = "";
            if (data.ConfirmedDateDisplay) {
              confirmedByHtml = `
                <div class="form-group col-md-5">
                  <label><b>Confirmed by</b></label>
                  <div>${data.ConfirmedBy} at ${data.ConfirmedDateDisplay}</div>
                </div>`;
            } else if (
              !data.ConfirmedDateDisplay &&
              data.CancelledDateDisplay
            ) {
              confirmedByHtml = `
                <div class="form-group col-md-5">
                  <label><b>Cancelled by</b></label>
                  <div>${data.CancelledBy} at ${data.CancelledDateDisplay}</div>
                </div>`;
            }

            let cancelledByHtml = "";
            if (data.ConfirmedDateDisplay && data.CancelledDateDisplay) {
              cancelledByHtml = `
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label><b>Cancelled by</b></label>
                    <div>${data.CancelledBy} at ${data.CancelledDateDisplay}</div>
                  </div>
                </div>
              `;
            }

            let html = `<html>
            <head>
              <style>
                @media print {
                  body {
                    -webkit-print-color-adjust: exact;
                    font-family: Arial, Helvetica, sans-serif;
                  }
                }
                body{
                  font-family: Arial, Helvetica, sans-serif;
                }
                @page{size:auto; margin:5mm;}
                h3{margin: 10px;}
                .text-center{text-align: center !important;}
                .row{
                  display: -ms-flexbox;
                  display: -webkit-box;
                  display: flex;
                  -ms-flex-wrap: wrap;
                  flex-wrap: wrap;
                  margin-right: -15px;
                  margin-left: -15px;
                }
                .form-row{
                  display: -ms-flexbox;
                  display: -webkit-box;
                  display: flex;
                  -ms-flex-wrap: wrap;
                  flex-wrap: wrap;
                  margin-right: -5px;
                  margin-left: -5px;
                }
                .form-group{
                  margin-bottom: 1rem;
                }
                .form-group label{
                  margin-bottom: 0.25rem;
                }
                .col-md-6{
                  -ms-flex: 0 0 46%;
                  -webkit-box-flex: 0;
                  flex: 0 0 46%;
                  max-width: 46%;
                  position: relative;
                  width: 100%;
                  padding-right: 15px;
                  padding-left: 15px;
                }
                .col-md-5{
                  -ms-flex: 0 0 41%;
                  -webkit-box-flex: 0;
                  flex: 0 0 41%;
                  max-width: 41%;
                  position: relative;
                  width: 100%;
                  padding-right: 15px;
                  padding-left: 15px;
                }
                .card{
                  border: 1px solid #a7a7a7;
                  -webkit-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2);
                  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2);
                  margin-bottom: 30px;
                  position: relative;
                  display: -ms-flexbox;
                  display: -webkit-box;
                  display: flex;
                  -ms-flex-direction: column;
                  -webkit-box-orient: vertical;
                  -webkit-box-direction: normal;
                  flex-direction: column;
                  min-width: 0;
                  word-wrap: break-word;
                  background-color: #fff;
                  background-clip: border-box;
                  border-radius: 0.25rem;
                }
                .card-header:first-child{
                  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
                }
                .card-header{
                  background-color: #fff;
                  padding: 0rem 1.25rem;
                  margin-bottom: 0;
                  border-bottom: 1px solid #a7a7a7;
                }
                .card-body{
                  font-size: 14px;
                  -ms-flex: 1 1 auto;
                  -webkit-box-flex: 1;
                  flex: 1 1 auto;
                  min-height: 1px;
                  padding-top: 0.5rem;
                  padding-bottom: 0.5rem;
                }
              </style>
            </head>
            <body>
              <div class="row">
                <div class="col-md-6">
                  <div class="card">
                    <div class="card-header text-center">
                      <h3>Booking Summary</h3>
                    </div>
                    <div class="card-body">
                      <div class="form-row">
                        <div class="form-group col-md-5">
                          <label><b>Submitted by</b></label>
                          <div>${data.SubmittedBy} at ${data.SubmittedDateDisplay}</div>
                        </div>
                        <div class="form-group col-md-5">
                          <label><b>School</b></label>
                          <div>${data.SchoolName}</div>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-5">
                          <label><b>Name</b></label>
                          <div>${data.StudentName}</div>
                        </div>
                        <div class="form-group col-md-5">
                          <label><b>Email</b></label>
                          <div>${data.StudentEmail}</div>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-5">
                          <label><b>Class Subject</b></label>
                          <div>${data.SubjectName}</div>
                        </div>
                        <div class="form-group col-md-5">
                          <label><b>Subject Level</b></label>
                          <div>${data.SubjectLevelName}</div>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-5">
                          <label><b>Duration</b></label>
                          <div>${data.Duration}</div>
                        </div>
                        <div class="form-group col-md-5">
                          <label><b>Make-up Class</b></label>
                          <div>${data.MakeupClass}</div>
                        </div>
                      </div>
                      ${locationHtml}
                      <div class="form-row">
                        <div class="form-group col-md-5">
                          <label><b>Date</b></label>
                          <div>${data.BookingDateDisplay}</div>
                        </div>
                        <div class="form-group col-md-5">
                          <label><b>Time</b></label>
                          <div>${data.BookingTime} (${data.TimezoneName})</div>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-5">
                          <label><b>Instructor</b></label>
                          <div>${data.InstructorName}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  ${paymentHtml}
                  <div class="card">
                    <div class="card-header text-center">
                      <h3>Status</h3>
                    </div>
                    <div class="card-body">
                      <div class="form-row">
                        <div class="form-group col-md-5">
                          <label><b>Status</b></label>
                          <div>${data.Status}</div>
                        </div>
                        ${confirmedByHtml}
                      </div>
                      ${cancelledByHtml}
                    </div>
                  </div>
                </div>
              </div>
            </body>
            </html>`;
            // let w = window.open("", "PRINT", "height=700,width=1300");
            // w.document.write(html);
            // // for i.e
            // w.document.close();
            // w.focus();
            // //for the rest
            // window.setTimeout(() => {
            //   w.print();
            //   w.close();
            // }, 500);
            const printFrame = document.createElement("iframe");
            printFrame.style.position = "absolute";
            printFrame.style.width = "0";
            printFrame.style.height = "0";
            printFrame.style.border = "none";
            document.body.appendChild(printFrame);
            const printDocument =
              printFrame.contentWindow || printFrame.contentDocument;
            printDocument.document.open();
            printDocument.document.write(html);
            printDocument.document.close();
            printFrame.contentWindow.focus();
            try {
              printFrame.contentWindow.print();
            } catch (e) {
              console.log(e.message);
            }
            printFrame.contentWindow.onafterprint = () => {
              document.body.removeChild(printFrame);
            };
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //for ph
    showAllPhCheckChange() {
      for (let item of this.countries) {
        item.Selected = this.showAllPh;
      }
      this.selectedCountries = this.showAllPh
        ? this.countries.map((c) => c.Id)
        : [];
      this.counter++;
    },
    countryCheckChange() {
      this.selectedCountries = this.countries
        .filter((c) => c.Selected == true)
        .map((c) => c.Id);
      this.showAllPh = this.selectedCountries.length == this.countries.length;
      this.counter++;
    },
    showPublicHoliday(payload) {
      if (payload) {
        this.eventName = payload.eventName;
        this.date = payload.date;
        this.country = payload.country;
        $("#phModal").modal("show");
      }
    },
    getInstructorCountries() {
      API.instructor
        .getInstructorCountries({
          Token: this.tokenObj.Token,
          Id: this.tokenObj.Id,
        })
        .then((response) => {
          if (response.data.success) {
            this.countries = response.data.data;
            for (let country of this.countries) {
              country.Selected = true;
            }
            this.selectedCountries = this.countries.map((c) => c.Id);
            this.showAllPh = true;
            this.counter++;
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getSchoolAddressCountries() {
      API.school
        .getSchoolAddressCountries({
          Token: this.tokenObj.Token,
          SchoolId:
            this.tokenObj.UserType == this.userTypeMainAdmin
              ? this.schoolId
              : this.tokenObj.SchoolId,
        })
        .then((response) => {
          if (response.data.success) {
            this.countries = response.data.data;
            for (let country of this.countries) {
              country.Selected = true;
            }
            this.selectedCountries = this.countries.map((c) => c.Id);
            this.showAllPh = true;
            this.counter++;
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getStudentLocationCountry() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.showPosition,
          this.showError,
          { timeout: 300000, maximumAge: 1800000 }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    },
    showPosition(position) {
      const { latitude, longitude } = position.coords;
      axios
        .get(
          `https://api.timezonedb.com/v2.1/get-time-zone?key=GS66VJW5BPIQ&format=json&by=position&lat=${latitude}&lng=${longitude}`
        )
        .then((response) => {
          if (response.status == 200) {
            let countryName = response.data.countryName;
            API.common
              .getCountries({ Token: this.tokenObj.Token })
              .then((response) => {
                if (response.data.success) {
                  let countries = response.data.data;
                  let country = countries.find((c) => c.Name == countryName);
                  if (country) {
                    this.countries.push({
                      Id: country.Id,
                      Name: country.Name,
                      Selected: true,
                    });
                    this.selectedCountries = this.countries.map((c) => c.Id);
                    this.showAllPh = true;
                    this.counter++;
                  }
                }
              })
              .catch((error) => {
                this.$swal(error.response.data.Message, { icon: "error" });
              });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    showError(error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          console.error("User denied the request for Geolocation.");
          break;
        case error.POSITION_UNAVAILABLE:
          console.error("Location information is unavailable.");
          break;
        case error.TIMEOUT:
          console.error("The request to get user location timed out.");
          break;
        case error.UNKNOWN_ERROR:
          console.error("An unknown error occurred.");
          break;
        default:
          console.error("An unknown error occurred.");
      }
    },
    //resize function
    resize() {
      window.setTimeout(() => {
        this.updateSize();
      }, 300);
    },
    updateSize() {
      let windowWidth = $(window).width();
      let scaleFactor = 1;
      let parentDivWidth = 1212.8;
      let sidebarWidth = $("div.sidebar").outerWidth();
      if (windowWidth > 1368) {
        $("div.parent-div").css({
          transform: `scale(${scaleFactor})`,
          width: "unset",
        });
      } else {
        let factor = 0.94;
        if (windowWidth > 991.98) {
          if (sidebarWidth < 61) {
            parentDivWidth = 1382.8;
            if (windowWidth >= 1351) {
              factor = 0.922;
            } else if (windowWidth >= 1165) {
              factor = 0.905;
            } else if (windowWidth >= 1009) {
              factor = 0.89;
            }
          } else {
            parentDivWidth = 1212.8;
            if (windowWidth >= 1351) {
              factor = 0.8;
            } else if (windowWidth >= 1165) {
              factor = 0.76;
            } else if (windowWidth >= 1009) {
              factor = 0.725;
            }
          }
        }
        scaleFactor = (windowWidth * factor) / parentDivWidth;
        $("div.parent-div").css({
          transform: `scale(${scaleFactor})`,
          width: parentDivWidth + "px",
        });
      }
      $("div.parent-div").css("transform-origin", `15px 0px`);
    },
  },

  created() {
    let selectedDate = this.$store.state.classBookingFilter.selectedDate;
    this.selectedDate = selectedDate ? selectedDate : this.todayDate;
    let selectedView = this.$store.state.classBookingFilter.selectedView;
    this.selectedView = selectedView ? selectedView : this.selectedView;
    //get countries for ph
    if (this.isInstructor) this.getInstructorCountries();
    else if (this.tokenObj.UserType == this.userTypeStudent)
      this.getStudentLocationCountry();
    else this.getSchoolAddressCountries();
  },

  mounted() {
    this.resize();
    window.addEventListener("resize", this.resize);
    //adjust word-spacing
    let userAgent = navigator.userAgent;
    let platform = navigator.userAgentData.platform || navigator.platform;
    let isWindow = /Win/i.test(platform);
    let isAndroid = /Android/i.test(userAgent);
    let isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
    let isMacos = /Mac/i.test(platform);
    if (isWindow || isAndroid || (isMacos && !isSafari)) {
      $(".ph-div").css("word-spacing", "-5px");
    }
  },
};
</script>

<style scoped>
.cal-div {
  max-width: fit-content;
  margin-bottom: 20px;
}
.ph-table {
  width: 100% !important;
}
.ph-div label,
.ph-div input[type="checkbox"] {
  cursor: pointer;
  text-align: left;
}
.ph-div .table thead th,
.ph-div .table tbody td {
  letter-spacing: 0px;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  white-space: unset;
  line-height: 17px;
}
.schedule-div {
  flex: 1;
}
.selected {
  background-color: #e2e6ea;
}
table {
  width: 100% !important;
}
.desktop-show {
  display: block;
}
.mobile-show {
  display: none;
}
@media only screen and (max-width: 431px) {
  .page-header {
    margin-bottom: 20px;
  }
  button.add-btn {
    font-size: 8px;
    max-width: fit-content !important;
    padding-top: 2px;
    padding-bottom: 1px;
    padding-left: 6px;
    padding-right: 6px;
  }
  h3.page-title {
    font-size: 14px;
    margin-bottom: 0 !important;
  }
  .w-xs-40 {
    width: 40% !important;
  }
  .w-xs-50 {
    width: 50% !important;
  }
  .desktop-show {
    display: none;
  }
  .mobile-show {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SchoolUser/SchoolAdmin/ClassBookingCalendarFormat.vue